import { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import RoleList from '../components/admin/RoleList';
import UserList from '../components/admin/UserList';
import DataList from '../components/admin/DataList';
import Notifications from '../components/admin/Notifications';

const TABS_DATA = [
  {
    key: 'users',
    label: 'Users',
    children: <UserList />,
  },
  {
    key: 'roles',
    label: 'Roles',
    children: <RoleList />,
  },
  {
    key: 'notifications',
    label: 'Notifications',
    children: <Notifications />,
  },
  {
    key: 'data',
    label: 'Data',
    children: <DataList />,
  },
];

function AdminPage() {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  return (
    <TabView activeIndex={selectedTabIndex} onTabChange={(e) => setSelectedTabIndex(e.index)}>
      {TABS_DATA.map((item) => (
        <TabPanel key={item.key} header={item.label}>
          {item.children}
        </TabPanel>
      ))}
    </TabView>
  );
}

export default AdminPage;
